import React from 'react';
import useScrollAnimation from "../constants/useScrollAnimation";
import './Legacy.css';

const LegacySection = ({ schoolData }) => {
  const [headerRef, isHeaderVisible] = useScrollAnimation(0.2);
  const [timelineRef, isTimelineVisible] = useScrollAnimation(0.15);

  const milestones = [
    {
      year: "1985",
      description: "Founded by the Roychowdhury brothers in West Bengal.",
      position: "legacy-top"
    },
    {
      year: "1990s",
      description: "Expanded into higher education with engineering and management colleges.",
      position: "legacy-bottom"
    },
    {
      year: "2000s",
      description: "Established a wide network of Techno India Group Public Schools across India.",
      position: "legacy-top"
    },
    {
      year: "2012",
      description: "Launched Techno India University, West Bengal – the state's first private university.",
      position: "legacy-bottom"
    },
    {
      year: "2015",
      description: "Diversified into healthcare, media, innovation and entrepreneurship initiatives.",
      position: "legacy-top"
    },
    {
      year: "2025",
      description: "India's leading educational conglomerate with a global alumni network, educating lakhs of students every year.",
      position: "legacy-bottom"
    }
  ];

  return (
    <section className="legacy-section gap-y">
      <div className="container-custom">
        <div ref={headerRef} className={`legacy-header ${isHeaderVisible ? "animate-in" : ""}`}>
          <div className="legacy-title-body">
            <div>
              <h3 className="section-title-hm">Legacy of TIG</h3>
            </div>
          </div>
          <p className="legacy-desc body-txt">
            Discover our journey of educational excellence, innovation, and empowering generations since 1985.
          </p>
        </div>

        <div ref={timelineRef} className={`legacy-timeline-container ${isTimelineVisible ? "animate-in" : ""}`}>
          <div className="legacy-timeline-track">
            <div className="legacy-timeline-line"></div>
            {milestones.map((milestone, index) => {
              const fraction = index / (milestones.length - 1);
              const leftStyle = fraction === 0
                ? '110px'
                : fraction === 1
                  ? 'calc(100% - 110px)'
                  : `calc(110px + ${fraction} * (100% - 220px))`;
              return (
                <div
                  key={index}
                  className={`legacy-timeline-item ${milestone.position} ${isTimelineVisible ? 'visible' : ''}`}
                  style={{ left: leftStyle, '--item-index': index }}
                >
                  <div className="legacy-timeline-content">
                    <div className="legacy-timeline-badge">{milestone.year}</div>
                    <p className="legacy-timeline-description">{milestone.description}</p>
                  </div>
                  <div className="legacy-timeline-stem"></div>
                  <div className="legacy-timeline-dot">
                    <span className="legacy-dot-inner"></span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegacySection;